module.exports = __webpack_public_path__ + "static/media/logo-dark.7e2042a7.png";